
  <div class="container-fluid">
      
        <div class=" row d-flex align-items-center pt-3 pb-3">
          <div class="col-12">
            <h4>
              <a [routerLink]="[strRutaHome]" title="Home">{{miga}}</a> / {{titulo}}
            </h4>
          </div>
          
        </div>
      <div class="row justify-content-evenly">
        <div class="card col-12 col-lg-7 shadow p-0 mb-5 bg-body rounded">
          <ul class="nav nav-tabs mt-3 ms-3" id="myTab" role="tablist">
            <li class="nav-item">
              <a (click)="yourFn(1)" class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab"
                aria-controls="home" aria-selected="true" data-bs-toggle="tab">Filtro Por Linea</a>
            </li>
            <li class="nav-item">
              <a (click)="yourFn(2)" class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab"
                aria-controls="profile" aria-selected="false" data-bs-toggle="tab">Filtro Por Almacenes</a>
            </li>
           
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row d-flex align-items-center justify-content-center">
                <div
                  [ngClass]="{'col-10':strLinea != 'PAPEL'&& strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','col-12':strLinea == 'PAPEL'|| strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}">
                  <div class="card-body col-12">
                    <div class="px-0 col-12">
                      <div class="row">
                        <div class="col-lg-6 col-lg-6  col-12 pt-3 pt-lg-2 ps-1">
                            <div class="input-group">
                                <div class="input-group-text">Linea</div>
                                <select [(ngModel)]="strLinea" class="form-select">
                                  <option *ngFor="let linea of arrayLineas" [value]="linea.strLinea">
                                    {{ linea.strLinea }}
                                    <span *ngIf="linea.strLinea == 'PAPEL' || linea.strLinea == 'ACCESORIOS G' || linea.strLinea == 'IMPORTADO' || linea.strLinea == 'QUIMICOS G'">
                                      ->
                                    </span>
                                  </option>
                                </select>
                              </div>
                        </div>
                        <div
                          *ngIf="strLinea=='PAPEL' ||strLinea=='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'"
                          class="mt-3 mt-lg-0 pe-lg-5  ps-lg-0 col-12 col-lg-6 d-flex align-items-center justify-content-center">
                          <button type="button" (click)="fnFiltroPapel();"
                            class="px-3  mb-lg-0 btn d-flex align-items-center">
                            <mat-icon>filter_list</mat-icon>
                          </button>
                        </div>
                        <div
                          [ngClass]="{'d-none':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                          class="col-12 col-lg-6 pt-3 pt-lg-2 ps-1">
                          <div class="input-group mb-3">
                            <label class="input-group-text px-1">Compras</label>
                            <select class="form-select" [(ngModel)]="intCompras" (change)="seleccionarValor($event)">
                              <option *ngFor="let item of arrayCompras" [value]="item?.value" [selected]="item?.value == intCompras">
                                {{ item.texto }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    [ngClass]="{'d-none': strLinea == 'PAPEL'||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G' }"
                    class="ms-lg-3 col-10 py-0 my-0">
                  <div
                    [ngClass]="{'pt-0': strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'  }"
                    class="card-body col-12 ">
                    <div
                      [ngClass]="{'d-none': strLinea == 'PAPEL'||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G' }"
                      class="row">
                      <div class="btn-group  col-12 pbtn " role="group" aria-label="Basic outlined example">
                        <button type="button" class="btn btn-outline-primarye">MES</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="1"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 1, 'btnOFF': strMes != 1}">1</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="1.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 1.5, 'btnOFF': strMes != 1.5}">1.5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="2"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 2, 'btnOFF': strMes != 2}">2</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="2.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 2.5, 'btnOFF': strMes != 2.5}">2.5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="3"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 3, 'btnOFF': strMes != 3}">3</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="3.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 3.5, 'btnOFF': strMes != 3.5}">3.5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="4"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 4, 'btnOFF': strMes != 4}">4</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="4.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 4.5, 'btnOFF': strMes != 4.5}">4.5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 5, 'btnOFF': strMes != 5}">5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="5.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 5.5, 'btnOFF': strMes != 5.5}">5.5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="6"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 6, 'btnOFF': strMes != 6}">6</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="6.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 6.5, 'btnOFF': strMes != 6.5}">6.5</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="7"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 7, 'btnOFF': strMes != 7}">7</button>
                        <button type="button" class="btn btn-outline-primarye" name="btnMes" value="7.5"
                          (click)="cambioStrmes($event,'filtro')"
                          [ngClass]="{'btnON': strMes == 7.5, 'btnOFF': strMes != 7.5}">7.5</button>
  
                      </div>
                    </div>
                    <div
                      [ngClass]="{'d-none': strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','d-flex': strLinea == 'PAPEL' || strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                      class="row justify-content-between px-2">
                      <div class="col-12 col-lg-4">
                        <div class="row">
                          <div class="card col-12 px-0">
                            <div class="card-header">
                              <div class="col-12 px-1 d-flex justify-content-center">
                                <label class="mb-0" for="">{{ strLinea === 'PAPEL' ? 'TORK' : (strLinea === 'ACCESORIOS G'
                                  ? 'ACCESORIOS' : (strLinea === 'IMPORTADO' ? 'RUBBERMAID' : (strLinea === 'QUIMICOS G'?
                                  'QUIMICOS':'' ))) }}</label>
                              </div>
                            </div>
                            <div class="card-body px-3 p-3">
                              <div class="row">
                                <div class="col-6 ps-1 d-flex justify-content-center">
                                  <label class="mb-0" for="">Mes</label>
                                </div>
                                <div class="col-6 pe-1 d-flex justify-content-center">
                                  <label class="mb-0" for="">Compras</label>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 px-1">
                                  <div class="input-group">
                                    <select class="form-select col-4" id="" [(ngModel)]="intMesT">
                                      <option *ngFor="let item of arrayMeses" [value]="item?.value"
                                        [selected]="item?.value == intMesT">{{ item.texto }}</option>
                                    </select>
                                    <select class="form-select" id="" [(ngModel)]="intComprasT">
                                      <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                        [selected]="item?.value == intComprasT">{{ item.texto }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="strLinea === 'PAPEL'" class="col-12 col-lg-4 my-4 my-lg-0">
                        <div class="row">
                          <div class="card col-12 px-0">
                            <div class="card-header">
                              <div class="col-12 px-1 d-flex justify-content-center">
                                <label class="mb-0" for="" clas>KIMBERLY</label>
                              </div>
                            </div>
                            <div class="card-body p-3">
                              <div class="row">
                                <div class="col-6 ps-1 d-flex justify-content-center">
                                  <label class="mb-0" for="">Mes</label>
                                </div>
                                <div class="col-6 pe-1 d-flex justify-content-center">
                                  <label class="mb-0" for="">Compras</label>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 px-1">
                                  <div class="input-group">
                                    <select class="form-select col-4" id="" [(ngModel)]="intMesK">
                                      <option *ngFor="let item of arrayMeses" [value]="item?.value"
                                        [selected]="item?.value == intMesK">{{ item.texto }}</option>
                                    </select>
                                    <select class="form-select" id="" [(ngModel)]="intComprasK">
                                      <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                        [selected]="item?.value == intComprasK">{{ item.texto }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4">
                        <div class="row">
                          <div class="card col-12 px-0">
                            <div class="card-header">
                              <div class="col-12 px-1 d-flex justify-content-center">
                                <label class="mb-0" for="">{{ strLinea === 'PAPEL' ? 'BLUE TISSUE' : (strLinea ===
                                  'ACCESORIOS G' ? 'DESPACHADORES' : (strLinea === 'IMPORTADO' ? 'DEGRAPACK' : (strLinea
                                  === 'QUIMICOS G'? 'FOAOM':'' ))) }}</label>
                              </div>
                            </div>
                            <div class="card-body p-3">
                              <div class="row">
                                <div class="col-6 ps-1 d-flex justify-content-center">
                                  <label class="mb-0" for="" clas>Mes</label>
                                </div>
                                <div class="col-6 pe-1 d-flex justify-content-center">
                                  <label class="mb-0" for="" clas>Compras</label>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 px-1">
                                  <div class="input-group">
                                    <select class="form-select col-4" id="" [(ngModel)]="intMesB">
                                      <option *ngFor="let item of arrayMeses" [value]="item?.value"
                                        [selected]="item?.value == intMesB">{{ item.texto }}</option>
                                    </select>
                                    <select class="form-select" id="" [(ngModel)]="intComprasB">
                                      <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                        [selected]="item?.value == intComprasB">{{ item.texto }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> <!-- {{intCompras}}--mes{{ strMes}} -->
                </div>
                <div
                  *ngIf="strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea != 'QUIMICOS G'"
                  class=" pe-lg-5  ps-lg-0 col-12 col-lg-2 d-flex align-items-center justify-content-center">
                  <button type="button" (click)="fnFiltroMes();"
                    class="px-3 mb-4 mb-lg-0 btn btn-filter d-flex align-items-center">
                    <mat-icon>filter_list</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <div class="row d-flex align-items-center justify-content-center">
                  <div
                    [ngClass]="{'col-10':strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','col-12':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}">
                    <div class="card-body col-12 pb-lg-0 pb-0 ">
                      <div class="col-12 px-0">
                        <div class="row">
                          <div
                            [ngClass]="{'col-lg-6':strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','col-lg-5':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                            class="col-12  pt-2">
                            <div class="input-group">
                              
                                <label class="input-group-text" for="inputGroupSelect01">Origen</label>
                              
                              <select class="form-select" id="inputGroupSelect01" [(ngModel)]="strAlm_Origen">
                                <option value="-1" selected>--Todos--</option>
                                <option value="{{A.strAlmacen}}" *ngFor="let A of arrayAlmacen">{{A.strNombreAlm}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div
                            [ngClass]="{'col-lg-6':strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','col-lg-5':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                            class="col-12 col-lg-6 pt-3 pt-lg-2 ps-1">
                            <div class="input-group">
                            
                                <label class="input-group-text" for="inputGroupSelect01">Destino</label>
                            
                              <select class="form-select" id="inputGroupSelect01" [(ngModel)]="strAlm_destino"
                                (change)="fnCambiaAlmdest(strAlm_destino)">
                                <option value="-1" selected>--Todos--</option>
                                <option value="{{A.strAlmacen}}" *ngFor="let A of arrayAlmacen">{{A.strNombreAlm}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <!-- filtro de linea agrupada -->
                          <div
                            *ngIf="strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'"
                            class="col-12 my-3 my-lg-0 col-lg-2 d-flex align-items-center justify-content-center">
                            <button type="button" (click)="fnFiltroPapel();"
                              class="px-3 mb-4 mb-lg-0 btn btn-filter d-flex align-items-center">
                              <mat-icon>filter_list</mat-icon>
                            </button>
                          </div>
                          <div
                            [ngClass]="{'d-none':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                            class="col-12 col-lg-6 pt-2">
                            <div class="input-group mb-3">
                              
                                <label class="input-group-text px-1">Compras</label>
                              
                              <select class="form-select" [(ngModel)]="intCompras" (change)="seleccionarValor($event)">
                                <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                  [selected]="item?.value == intCompras">{{ item.texto }}</option>
                              </select>
                            </div>
                          </div>
                          <div
                            [ngClass]="{'col-lg-6 ps-1':strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','col-lg-5':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                            class="col-12 pt-2 ">
                            <div class="input-group">
                              
                                <label class="input-group-text">Linea</label>
                              
                              <select [(ngModel)]="strLinea"
                                class="form-select"><!-- (ngModelChange)="fnFiltroMes(strLinea,strMes);" -->
                                <option value="-1" selected>--Todas--</option>
                                <option *ngFor="let linea of arrayLineas" value="{{linea.strLinea}}">{{linea.strLinea}}
                                  <span
                                    *ngIf="linea.strLinea =='PAPEL'||linea.strLinea =='ACCESORIOS G'|| linea.strLinea =='IMPORTADO' || linea.strLinea =='QUIMICOS G'">
                                    -></span>
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        [ngClass]="{'d-none': strLinea != 'PAPEL' && strLinea !='ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea !='QUIMICOS G','d-flex': strLinea == 'PAPEL' || strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                        class="row justify-content-between  my-3">
                        <div class="col-12 col-lg-4">
                          <div class="row">
                            <div class="card col-12 px-0">
                              <div class="card-header">
                                <div class="col-12 px-1 d-flex justify-content-center">
                                  <label class="mb-0" for="">{{ strLinea === 'PAPEL' ? 'TORK' : (strLinea === 'ACCESORIOS G' ? 'ACCESORIOS' : (strLinea === 'IMPORTADO' ? 'RUBBERMAID' : (strLinea === 'QUIMICOS G'? 'QUIMICOS':'' ))) }}</label>
                                </div>
                              </div>
                              <div class="card-body p-3">
                                <div class="row">
                                  <div class="col-6 ps-1 d-flex justify-content-center">
                                    <label class="mb-0" for="">Mes</label>
                                  </div>
                                  <div class="col-6 pe-1 d-flex justify-content-center">
                                    <label class="mb-0" for="">Compras</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12 px-1">
                                    <div class="input-group">
                                      <select class="form-select col-4" id="" [(ngModel)]="intMesT">
                                        <option *ngFor="let item of arrayMeses" [value]="item?.value"
                                          [selected]="item?.value == intMesT">{{ item.texto }}</option>
                                      </select>
                                      <select class="form-select" id="" [(ngModel)]="intComprasT">
                                        <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                          [selected]="item?.value == intComprasT">{{ item.texto }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="strLinea === 'PAPEL'" class="col-12 col-lg-4 my-4 my-lg-0">
                          <div class="row">
                            <div class="card col-12 px-0">
                              <div class="card-header">
                                <div class="col-12 px-1 d-flex justify-content-center">
                                  <label class="mb-0" for="" clas>KIMBERLY</label>
                                </div>
                              </div>
                              <div class="card-body p-3">
                                <div class="row">
                                  <div class="col-6 ps-1 d-flex justify-content-center">
                                    <label class="mb-0" for="">Mes</label>
                                  </div>
                                  <div class="col-6 pe-1 d-flex justify-content-center">
                                    <label class="mb-0" for="">Compras</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12 px-1">
                                    <div class="input-group">
                                      <select class="form-select col-4" id="" [(ngModel)]="intMesK">
                                        <option *ngFor="let item of arrayMeses" [value]="item?.value"
                                          [selected]="item?.value == intMesK">{{ item.texto }}</option>
                                      </select>
                                      <select class="form-select" id="" [(ngModel)]="intComprasK">
                                        <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                          [selected]="item?.value == intComprasK">{{ item.texto }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="row">
                            <div class="card col-12 px-0">
                              <div class="card-header">
                                <div class="col-12 px-1 d-flex justify-content-center">
                                  <label class="mb-0" for="">{{ strLinea === 'PAPEL' ? 'BLUE TISSUE' : (strLinea ===
                                    'ACCESORIOS G' ? 'DESPACHADORES' : (strLinea === 'IMPORTADO' ? 'DEGRAPACK' : (strLinea
                                    === 'QUIMICOS G'? 'FOAOM':'' ))) }}</label>
                                </div>
                              </div>
                              <div class="card-body p-3">
                                <div class="row">
                                  <div class="col-6 ps-1 d-flex justify-content-center">
                                    <label class="mb-0" for="" clas>Mes</label>
                                  </div>
                                  <div class="col-6 pe-1 d-flex justify-content-center">
                                    <label class="mb-0" for="" clas>Compras</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12 px-1">
                                    <div class="input-group">
                                      <select class="form-select col-4" id="" [(ngModel)]="intMesB">
                                        <option *ngFor="let item of arrayMeses" [value]="item?.value"
                                          [selected]="item?.value == intMesB">{{ item.texto }}</option>
                                      </select>
                                      <select class="form-select" id="" [(ngModel)]="intComprasB">
                                        <option *ngFor="let item of arrayCompras" [value]="item?.value"
                                          [selected]="item?.value == intComprasB">{{ item.texto }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr
                      [ngClass]="{'d-none':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                      class="ms-lg-3 col-10 py-0 my-0">
                    <div
                      [ngClass]="{'d-none':strLinea == 'PAPEL' ||strLinea =='ACCESORIOS G'|| strLinea =='IMPORTADO' || strLinea =='QUIMICOS G'}"
                      class="card-body col-12 ">
                      <div class="row">
                        <div class="btn-group  col-12 pbtn " role="group" aria-label="Basic outlined example">
                          <button type="button" class="btn btn-outline-primarye">MES</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="1"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 1, 'btnOFF': strMesAlm != 1}">1</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="1.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 1.5, 'btnOFF': strMesAlm != 1.5}">1.5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="2"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 2, 'btnOFF': strMesAlm != 2}">2</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="2.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 2.5, 'btnOFF': strMesAlm != 2.5}">2.5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="3"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 3, 'btnOFF': strMesAlm != 3}">3</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="3.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 3.5, 'btnOFF': strMesAlm != 3.5}">3.5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="4"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 4, 'btnOFF': strMesAlm != 4}">4</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="4.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 4.5, 'btnOFF': strMesAlm != 4.5}">4.5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 5, 'btnOFF': strMesAlm != 5}">5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="5.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 5.5, 'btnOFF': strMesAlm != 5.5}">5.5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="6"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 6, 'btnOFF': strMesAlm != 6}">6</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="6.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 6.5, 'btnOFF': strMesAlm != 6.5}">6.5</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="7"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 7, 'btnOFF': strMesAlm != 7}">7</button>
                          <button type="button" class="btn btn-outline-primarye" name="btnMes" value="7.5"
                            (click)="cambioStrmes($event,'almacen')"
                            [ngClass]="{'btnON': strMesAlm == 7.5, 'btnOFF': strMesAlm != 7.5}">7.5</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="strLinea != 'PAPEL' && strLinea != 'ACCESORIOS G' && strLinea !='IMPORTADO' && strLinea != 'QUIMICOS G'"
                    class=" pe-lg-5  ps-lg-0 col-12 col-lg-2 d-flex align-items-center justify-content-center">
                    <button type="button" (click)="fnFiltroMes();"
                      class="px-3 mb-4 mb-lg-0 btn btn-filter d-flex align-items-center">
                      <mat-icon>filter_list</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <!--  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div> -->
            </div>
          </div>
        </div>
  
  
        <div class="card col-12 col-lg-4 shadow mb-5 bg-body rounded p-0">
          <div class="card-header d-flex align-items-center">
            <b>Indicadores</b>  <button type="button" class="btn btn-primary ms-2 fs12 fw-bold d-flex align-items-center py-1 px-2" (click)="fnIrReglas()"><i class="bi bi-info-circle-fill fs14 me-2"></i> <span>Reglas</span> </button>
          </div>
          <div class="card-body ">
            <div class="row d-flex ">
              <div class="col-4">
                <h5 class="mb-0"><mat-icon class="mat-18 excedente">radio_button_checked</mat-icon>&nbsp;Excedente</h5>
              </div>
              <div class="col-4">
                <h5 class="mb-0"><mat-icon class="mat-18 faltante">radio_button_checked</mat-icon>&nbsp;Faltante</h5>
              </div>
              <div class="col-4">
                <h5 class="mb-0"><mat-icon class="mat-18 promedio">radio_button_checked</mat-icon>&nbsp;Promedio</h5>
              </div>
            </div>
            <hr class="col-11 ">
            <div class="row d-flex justify-content-center position-relative">
            <div  class="d-flex col-12 text-center flex-column" *ngIf="!spiner" >
                <div class="row">
                    <div class="col-12">
                        <button mat-raised-button class="btn btn-success text-wrap fs14 fw-bold col-9" (click)="fnIrTransitos()">Generar Transitos <mat-icon>swap_horizontal_circle</mat-icon></button>
                    </div>
                    <div class="col-12 mt-3">

                      <button  mat-raised-button color="primary" class="col-9" [matMenuTriggerFor]="menu" >Generar Ordenes de Compra <mat-icon>note_add</mat-icon></button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item class="bgDistribucion" (click)="fnIrCompras(1)"> Con Distribución <mat-icon class="bgDistribucion"> zoom_out_map</mat-icon></button>
                        <button mat-menu-item class="bgFaltante" (click)="fnIrCompras(2)">Todo El Faltante <mat-icon class="bgFaltante">warning</mat-icon></button>
                      </mat-menu>


                        <!-- <div class="dropdown">
                            <a class="btn btn-primary dropdown-toggle fs13" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                Generar Ordenes de Compra
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <li>
                                    <button class="btn btn-warning fs12 dropdown-item"  (click)="fnIrCompras(1)">Con Distribución</button>
                                </li>
                                <li>
                                    <button class="btn btn-danger dropdown-item fs12"  (click)="fnIrCompras(2)">Todo El Faltante</button>
                                </li>
                            </ul>
                          </div> -->
                    </div>
                </div>
              </div>
           <div *ngIf="spiner" class="text-center col-12 d-flex justify-content-center align-items-center position-absolute top-0 start-50 translate-middle-x"  [ngClass]="{'hdiv-75': spiner}">
                <mat-spinner [diameter]="40"></mat-spinner>
              </div>
            </div>
          </div>
        </div>
  
      </div>
     
  
    <div class=" row  ">
      <div class="shadow p-3 col-12 bg-body rounded">
        <div class="p-0 w-100">
          <div class="w-100">
            <div class="row d-flex justify-content-between m-0">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6  mb-3">
                <input type="text" (keyup)="filterArray()" class="form-control" name="filterData" placeholder="Buscar"
                  [(ngModel)]="filterData">
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 mb-3 ">
                <button class="btn btn-success d-flex  align-items-center" (click)="fntransitosGen()">Transitos
                  Generados<mat-icon class="mx-2"> local_shipping</mat-icon></button>
              </div>
            </div>
            <div class="text-center" *ngIf="spiner">
              <loader></loader>
            </div>
  
  
            <div class=" table-responsive" *ngIf="!spiner">
              <table class="table table-hover table-bordered mb-0 " id="tabla">
                <thead class="topsticky">
                  <tr class="cabecera text-fz3">
                    <th class="text-center sticky-col">
                      <div class="d-flex" (click)="funOrdenar('articulo',orderArticulo);">Artículo
                        <!-- <i class="ms-2 d-flex align-items-center"
                          (click)="funOrdenar('articulo',orderArticulo);"
                          [ngClass]="{'fa': true, 'fa-arrow-down': orderArticulo == 0, 'fa-solid': true, 'fa-arrow-up': orderArticulo == 1}"></i> -->
                          <mat-icon class="ms-2 d-flex align-items-center fs-15" >
                            {{orderArticulo == 0 ? 'arrow_downward': ''}} {{orderArticulo == 1 ? 'arrow_upward': ''}}</mat-icon>
                      </div>
                    </th>
                    <th class="text-center ">Descripción</th>
                    <th class="text-center text-nowrap">Opcion</th>
                    <th class="text-center text-nowrap">Unidad</th>
                    <th class="text-center  sticky-col2">
                      <div class="d-flex" (click)="funOrdenar('totalFaltante',totalFaltante);"> TOTAL FALTANTE
                        <!-- <i class="ms-2 d-flex align-items-center"
                          (click)="funOrdenar('totalFaltante',totalFaltante);"
                          [ngClass]="{'fa': true, 'fa-arrow-down': totalFaltante == 0, 'fa-solid': true, 'fa-arrow-up': totalFaltante == 1}"></i> -->
                          <mat-icon class="ms-2 d-flex align-items-center fs-15" >
                            {{totalFaltante == 0 ? 'arrow_downward': ''}} {{totalFaltante == 1 ? 'arrow_upward': ''}}</mat-icon>
                      </div>
                    </th>
                    <th class="text-center  sticky-col3 ">
                      <div class="d-flex" (click)="funOrdenar('totalExcedente',totalExcedente);"> TOTAL EXCEDENTE
                        <!-- <i class="ms-2 d-flex align-items-center"
                          [ngClass]="{'fa': true, 'fa-arrow-down': totalExcedente == 0, 'fa-solid': true, 'fa-arrow-up': totalExcedente == 1}"></i> -->
                          <mat-icon class="ms-2 d-flex align-items-center fs-15">{{totalExcedente == 0 ? 'arrow_downward': ''}} {{totalExcedente == 1 ? 'arrow_upward': ''}}</mat-icon>
                      </div>
                    </th>
                    <th class="text-center stick4">
                      <div class="d-flex" (click)="funOrdenar('totales',totales);"> TOTAL
                        <!-- <i class="ms-2 d-flex align-items-center"
                        [ngClass]="{'fa': true, 'fa-arrow-down': totales == 0, 'fa-solid': true, 'fa-arrow-up': totales == 1}"></i> -->
                          <mat-icon class="ms-2 d-flex align-items-center fs-15">{{totales == 0 ? 'arrow_downward': ''}} {{totales == 1 ? 'arrow_upward': ''}}</mat-icon>
                      </div>
                    </th>
                    <th class="text-center text-nowrap " *ngFor="let dato of arrayEncabezado"><a (click)="fnIrReporteFaltantes(dato.strAlmacen)">{{dato.strNombreAlm}}</a></th>
                  </tr>
                  <tr class="cabecera text-fz3">
                    <th class="text-center p-0 sticky-col"></th>
                    <th class="text-center p-0 "></th>
                    <th class="text-center p-0 "></th>
                    <th class="text-center p-0"></th>
                    <th class="text-center p-0 sticky-col2"></th>
                    <th class="text-center p-0 sticky-col3"></th>
                    <th class="text-center p-0 stick4"></th>
                    <th class="text-center py-0" *ngFor="let dato of arrayEncabezado">
                      <div class="row text-right w150">
                        <div class="col-4 p-0 text-nowrap text-center  fztxt0">
                          Excedente
                        </div>
                        <div class="col-4 p-0 text-nowrap   border-left text-center  fztxt0">
                          Faltante
                        </div>
                        <div class="col-4 p-0 text-nowrap border-left text-center fztxt0">
                          Promedio
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let A of filteredArray?.slice((paginaActual-1)*elementosPorPagina, paginaActual*elementosPorPagina); let i=index">
                    <!-- | filterPlaneador:filterData  | orderBy:propertyName:reverse | filter: strBuscar |filter:intFaltante-->
                    <td class="sticky-col"><b>{{A.strArticulo}}</b></td>
                    <td class="descrip text-nowrap" style="white-space: normal;"
                      [innerHTML]="formatDescripcion(A.strDescripcion,A.strLinea)">
                      <!--{{formatDescripcion(A.strDescripcion)}} {{A.strDescripcion }}--> </td>
                    <td class="text-nowrap">{{A.strOpcion}} {{A.strNombreOpcion}}</td>
                    <td class="text-nowrap">{{A.strUnidad}} </td>
                    <td class="text-center sticky-col2 faltante ">
                      <label for="">
                        <div
                          [ngClass]="{'excedente': A.totalAlmFaltante > 0, 'faltante': A.totalAlmFaltante < 0, 'sinexistencia': A.totalAlmFaltante == 0}">
                          {{A.totalAlmFaltante * -1}}
                        </div>
                      </label>
                    </td>
                    <td class="text-center excedente  sticky-col3">
                      <label for="">
                        <div
                          [ngClass]="{'excedente': A.totalAlmExcedente > 0, 'faltante': A.totalAlmExcedente < 0, 'sinexistencia': A.totalAlmExcedente == 0}">
                          {{A.totalAlmExcedente}}
                        </div>
                      </label>
                    </td>
                    <td class="text-center  termina stick4">
                      <label class="rounded  bg-light px-1 fzla"
                        [ngClass]="{'excedente': (A.totalAlmExcedente + A.totalAlmFaltante) > 0, 'faltante': (A.totalAlmExcedente + A.totalAlmFaltante)< 0, 'sinexistencia': (A.totalAlmExcedente + A.totalAlmFaltante) == 0}">
                        {{A.total < 0 ? (A.total * -1) : A.total}} </label>
                    </td>
                    <td *ngFor="let alm of arrayEncabezado" class="pb-0">
                      <div class="row text-right w150">
                        <!-- excedente -->
                        <div class="col-4 text-center campo px-1">
                          <div *ngIf="A['alM'+alm.strAlmacen] > 0; else elseBlock"
                            [ngClass]="{'excedente': A['alM'+alm.strAlmacen] > 0, 'faltante': A['alM'+alm.strAlmacen] < 0, 'sinexistencia': A['alM'+alm.strAlmacen] == 0}">
                            <a (click)="abreModal(existencia,A.strArticulo,A.strOpcion,alm.strAlmacen,A.strLinea)">
                              {{A['alM'+alm.strAlmacen]}}
                            </a>
                          </div>
                          <ng-template #elseBlock>
                            <span style="color:#a0a0a0 !important;font-weight: 600;">0</span>
                          </ng-template>
                        </div>
                        <!--Faltante-->
                        <div class="col-4 text-center campo px-1">
                          <div *ngIf="A['alM'+alm.strAlmacen] < 0; else elseBlock"
                            [ngClass]="{'excedente': A['alM'+alm.strAlmacen] > 0, 'faltante': A['alM'+alm.strAlmacen] < 0, 'sinexistencia': A['alM'+alm.strAlmacen] == 0}">
                            <a (click)="abreModal(existencia,A.strArticulo,A.strOpcion,alm.strAlmacen,A.strLinea)">
                              {{A['alM'+alm.strAlmacen] * -1}}
                            </a>
                          </div>
                          <ng-template #elseBlock>
                            <span style="color:#a0a0a0 !important;font-weight: 600;">0</span>
                          </ng-template>
                        </div>
                        <!--Promedio-->
                        <div class="col-4 promedio text-center px-1">
                          <label for=""> {{A['alM'+alm.strAlmacen+'P']}}</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="sticky-colbot">
                    <td class="sticky-col text-white" style="background: #0c3e72;"><b>Totales</b></td>
                    <td style="background: #0c3e72;"> </td>
                    <td style="background: #0c3e72;"> </td>
                    <td style="background: #0c3e72;"> </td>
                    <td class="text-center sticky-col2 faltante" style="background: #0c3e72;">
                      <label class="rounded  bg-white px-1 fzla">
                        {{sumasTotales.totalAlmFaltante| number:'1.2-2'}}
                      </label>
                    </td>
                    <td class="text-center excedente  sticky-col3" style="background: #0c3e72;">
                      <label class="rounded  bg-white px-1 fzla">
                        {{sumasTotales.totalAlmExcedente| number:'1.2-2'}}
                      </label>
                    </td>
                    <td class="text-center stick4" style="background: #0c3e72;">
                      <label class="rounded  bg-white px-1 fzla"
                        [ngClass]="{'excedente':sumasTotales.total > 0, 'faltante': sumasTotales.total < 0, 'sinexistencia': sumasTotales.total == 0}">
                        {{sumasTotales.total| number:'1.2-2'}}
                      </label>
                    </td>
                    <td style="background: #0c3e72;" class="text-center py-0" *ngFor="let dato of arrayEncabezado">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center sticky-col m-0 pt-2">
              <div class=" d-flex">
                <label for="" class="w-100">Objetos por pagina:</label>
                <select class="form-control form-select form-select-lg fs13 " [(ngModel)]="elementosPorPagina"
                  (ngModelChange)="onElementosPorPaginaChange()" aria-label=".form-select-lg example">
                  <option value="15" selected>15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div class="">
                <div class="btn-group">
                  <button class="btn btn-primary me-1 d-flex align-items-center " (click)="paginaActual = 1"
                    [disabled]="paginaActual === 1"><mat-icon>first_page</mat-icon></button>
                  <button class="btn btn-primary me-1 d-flex align-items-center" (click)="paginaActual = paginaActual - 1"
                    [disabled]="paginaActual === 1"> <mat-icon>navigate_before</mat-icon></button>
                  <span class="align-self-center btn">{{ paginaActual }} de {{ totalpaginas ? totalpaginas : 1
                    }}</span>
                  <button class="btn btn-primary me-1 d-flex align-items-center" (click)="paginaActual = paginaActual + 1"
                    [disabled]="paginaActual === getTotalPaginas()"><mat-icon>navigate_next</mat-icon></button>
                  <button class="btn btn-primary me-1 d-flex align-items-center"
                    (click)="paginaActual = getTotalPaginas()"
                    [disabled]="paginaActual === getTotalPaginas()"><mat-icon>last_page</mat-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!--MODAL TIEMPOS-->
    <ng-template #existencia let modal>
      <div *ngIf="intCompras==1 ||intCompras==0; else elseBlock">
        <div class="modal-header d-flex flex-column p-0 mt-2">
  
          <div class="row w-100">
            <div class="col-12 d-flex justify-content-between align-items-center">
              <h4 class="modal-title mx-auto mb-0 fs-6">
                <span>EXCEDENTE</span>/
                <span>FALTANTE</span>/<b *ngIf="intCompras==1">CON COMPRAS</b><b *ngIf="intCompras==0">SIN COMPRAS</b>
              </h4>
              <button class="ms-0 close p-0 fs-6" aria-label="close" type="button" (click)="cerrarModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
           
          </div>
          <div class="row fs-6 d-flex align-items-center col-12 justify-content-center" *ngFor="let A of arrayTotales">
            <div *ngIf="A.strEstatusxAlm == 'BAJAROTACION'">
              <h1>BAJA ROTACION</h1>
            </div>
            <div *ngIf="A.strEstatusxAlm == 'ALTA'">
              <h1>ALTA</h1>
            </div>
            <div *ngIf="A.strEstatusxAlm == 'SOBREPEDIDO'">
              <h1>SOBRE PEDIDO</h1>
            </div>
            <div *ngIf="A.strEstatusxAlm == 'BAJA'">
              <h1>BAJA</h1>
            </div>
          </div>
  
        </div>
  
        <div class="modal-body ">
          <div class="col-12" *ngFor="let A of arrayTotales">
            <!--  si no es baja ingresa a la condicional -->
            <div *ngIf="A.strEstatusxAlm !== 'BAJA'; else elseBlock">
              <div class="row table-responsive">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr *ngIf="A.strEstatusxAlm == 'BAJAROTACION' && A.dblValor < 0 && (intCompras==1 ||intCompras==0)"
                      class="cabecera tam">
                      <th>Existencia</th>
                      <th></th>
                      <th>Promedio</th>
                      <th></th>
                      <th>Por Vender</th>
                      <th></th>
                      <th>Transito</th>
                      <th *ngIf="intCompras==1"></th>
                      <th *ngIf="intCompras==1">Por Llegar</th>
                      <th></th>
                      <th>Total</th>
                      <th>Excedente</th>
                      <th>Faltante</th>
                    </tr>
                    <tr *ngIf="A.strEstatusxAlm == 'ALTA' && A.dblValor < 0 && (intCompras==1 ||intCompras==0)"
                      class="cabecera tam">
                      <th>Existencia</th>
                      <th></th>
                      <th>Promedio<br>*<br>Mes</th>
                      <th></th>
                      <th>Por Vender</th>
                      <th></th>
                      <th>Transito</th>
                      <th *ngIf="intCompras==1"></th>
                      <th *ngIf="intCompras==1">Por Llegar</th>
                      <th></th>
                      <th>Total</th>
                      <th>Excedente</th>
                      <th>Faltante</th>
                    </tr>
                    <tr *ngIf="A.strEstatusxAlm == 'SOBREPEDIDO' && A.dblValor < 0 && (intCompras==1 ||intCompras==0)"
                      class="cabecera tam">
                      <th>Existencia</th>
                      <th></th>
                      <th>Por Vender</th>
                      <th></th>
                      <th>Transito</th>
                      <th *ngIf="intCompras==1"></th>
                      <th *ngIf="intCompras==1">Por Llegar</th>
                      <th></th>
                      <th>Total</th>
                      <th>Excedente</th>
                      <th>Faltante</th>
                      <th>Promedio</th>
                    </tr>
                    <tr *ngIf=" A.dblValor > 0  && (intCompras==1 || intCompras==0)" class="cabecera tam">
                      <th>Existencia</th>
                      <th></th>
                      <th>Promedio<br>*<br>Mes</th>
                      <th></th>
                      <th>Por Vender</th>
                      <th></th>
                      <th>Transito</th>
                      <th *ngIf="intCompras==1"></th>
                      <th *ngIf="intCompras==1">Por Llegar</th>
                      <th></th>
                      <th>Total</th>
                      <th>Excedente</th>
                      <th>Faltante</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="A.strEstatusxAlm == 'BAJAROTACION' && A.dblValor < 0 && ( intCompras==1 || intCompras==0)"
                      class="cent">
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intExistencia}}</span>
                      </td>
                      <td class="px-0">
                        <span class="bg-light text-dark rounded p-1 ">-</span>
                      </td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.dblPromedio}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">-</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorvender}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intTransito}}</span>
                      </td>
                      <td class="px-0" *ngIf="intCompras==1"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td *ngIf="intCompras==1">
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorSurtir}}</span>
                      </td>
                      <td class="px-0">
                        <span class="bg-light text-dark rounded p-1 ">=</span>
                      </td>
                      <td>
                        <span *ngIf="intCompras==1" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-A.dblPromedio-A.intPorvender+A.intTransito+A.intPorSurtir}}</span>
                        <span *ngIf="intCompras==0" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-A.dblPromedio-A.intPorvender+A.intTransito}}</span>
                      </td>
                      <td class="bg-light"> <span *ngIf="A.dblValor > 0" class="bg-success rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor <= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                      <td class="bg-light"><span *ngIf="A.dblValor < 0" class="bg-danger rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor >= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                    </tr>
                    <tr *ngIf="A.strEstatusxAlm == 'ALTA' && A.dblValor < 0 && ( intCompras==1 ||intCompras==0 )"
                      class="cent">
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intExistencia}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">-</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">( {{A.dblPromedio}} x {{strMes}})</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">-</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorvender}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intTransito}}</span>
                      </td>
                      <td *ngIf="intCompras==1" class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td *ngIf="intCompras==1">
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorSurtir}}</span>
                      </td>
                      <td class="px-0">
                        <span class="bg-light text-dark rounded p-1 ">=</span>
                      </td>
                      <td>
                        <span *ngIf="intCompras==1" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-(A.dblPromedio*strMes)-A.intPorvender+A.intTransito+A.intPorSurtir}}</span>
                        <span *ngIf="intCompras==0" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-(A.dblPromedio*strMes)-A.intPorvender+A.intTransito}}</span>
                      </td>
                      <td class="bg-light"> <span *ngIf="A.dblValor > 0" class="bg-success rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor <= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                      <td class="bg-light"><span *ngIf="A.dblValor < 0" class="bg-danger rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor >= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                    </tr>
                    <tr *ngIf="A.strEstatusxAlm == 'SOBREPEDIDO' && A.dblValor < 0 && ( intCompras==1 || intCompras==0 )"
                      class="cent">
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intExistencia}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">-</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorvender}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intTransito}}</span>
                      </td>
                      <td *ngIf="intCompras==1" class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td *ngIf="intCompras==1">
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorSurtir}}</span>
                      </td>
                      <td class="px-0">
                        <span class="bg-light text-dark rounded p-1 ">=</span>
                      </td>
                      <td>
                        <span *ngIf="intCompras==1" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-A.intPorvender+A.intTransito+A.intPorSurtir}}</span>
                        <span *ngIf="intCompras==0" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-A.intPorvender+A.intTransito}}</span>
                      </td>
                      <td class="bg-light"> <span *ngIf="A.dblValor > 0" class="bg-success rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor <= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                      <td class="bg-light"><span *ngIf="A.dblValor < 0" class="bg-danger rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor >= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.dblPromedio}}</span>
                      </td>
                    </tr>
                    <tr *ngIf="A.dblValor > 0 && (intCompras==1 ||intCompras==0)" class="cent">
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intExistencia}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">-</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">( {{A.dblPromedio}} x {{strMes}})</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">-</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorvender}}</span>
                      </td>
                      <td class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td>
                        <span class="bg-secondary rounded p-1 text-white">{{A.intTransito}}</span>
                      </td>
                      <td *ngIf="intCompras==1" class="px-0"><span class="bg-light text-dark rounded p-1 ">+</span></td>
                      <td *ngIf="intCompras==1">
                        <span class="bg-secondary rounded p-1 text-white">{{A.intPorSurtir}}</span>
                      </td>
                      <td class="px-0">
                        <span class="bg-light text-dark rounded p-1 ">=</span>
                      </td>
                      <td>
                        <span *ngIf="intCompras==0" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-(A.dblPromedio*strMes)-A.intPorvender+A.intTransito}}</span>
                        <span *ngIf="intCompras==1" style="background: #1C3150;" class=" rounded p-1 text-white">
                          {{A.intExistencia-(A.dblPromedio*strMes)-A.intPorvender+A.intTransito+A.intPorSurtir}}</span>
                      </td>
                      <td class="bg-light"><span *ngIf="A.dblValor > 0" class="bg-success rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor <= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                      <td class="bg-light"><span *ngIf="A.dblValor < 0" class="bg-danger rounded p-1 text-white">
                          {{A.dblValor}}</span> <span *ngIf="A.dblValor >= 0"
                          class="bg-secondary rounded p-1 text-white">0</span> </td>
                    </tr>
                  </tbody>
                </table>
  
                <!-- tabla de meses ///////////////////////////// -->
                <div class="row mt-4 table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr class="cabecera tam">
                        <th>Mes 1</th>
                        <th>Mes 2</th>
                        <th>Mes 3</th>
                        <th>Mes 4</th>
                        <th>Mes 5</th>
                        <th>Mes 6</th>
                        <th>Mes Actual</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="cent">
                        <td><span class="bg-secondary rounded p-1 text-white">{{A.dblMes1}}</span> </td>
                        <td><span class="bg-secondary rounded p-1 text-white">{{A.dblMes2}}</span></td>
                        <td><span class="bg-secondary rounded p-1 text-white">{{A.dblMes3}}</span></td>
                        <td><span class="bg-secondary rounded p-1 text-white">{{A.dblMes4}}</span></td>
                        <td><span class="bg-secondary rounded p-1 text-white">{{A.dblMes5}}</span></td>
                        <td><span class="bg-secondary rounded p-1 text-white">{{A.dblMes6}}</span></td>
                        <td class="bg-white"><span style="font-size:17px"
                            class="bg-light rounded p-1 text-dark"><b>{{A.dblMesA}}</b></span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--termina tabla de meses ///////////////////////////// -->
              </div>
            </div>
  
            <!-- si es baja el de baja ingresa al else -->
            <ng-template #elseBlock>
              <div class="alert alert-danger" role="alert">
                0
              </div>
            </ng-template>
          </div>
  
          <!-- DESVIACIÓN ESTANDAR FIN -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" (click)="cerrarModal()">Cerrar</button>
        </div>
      </div>
      <ng-template #elseBlock>
        <div class="row my-3 justify-content-center">
          <div class="col-10 text-center" >
            <div class="col-12 d-flex">
              <h2 class="modal-title mx-auto">Error</h2>
              <button type="button" (click)="cerrarModal()" class="ms-0 btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> 
            <div class="alert alert-danger">Seleccione compras</div>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <!--MODAL-->
  


  